type GetEsbConnectorUrlParams = {
  connectorReturnUrl: string;
  userExists?: boolean;
  error?: boolean;
};

export const appendQueryParamToUrl = (url: string, queryParam: string) =>
  `${url}${queryParam && (/\?/.test(url) ? '&' : '?')}${queryParam}`;

export const getEsbConnectorUrl = ({
  connectorReturnUrl,
  userExists = false,
  error = false,
}: GetEsbConnectorUrlParams) => {
  if (connectorReturnUrl === '') return '';
  const searchParams = new URLSearchParams();

  if (userExists) searchParams.append('userExists', 'true');
  if (error) {
    searchParams.append('success', 'false');
    searchParams.append('process', 'error');
  }
  if (!userExists && !error) searchParams.append('process', 'success');

  return appendQueryParamToUrl(connectorReturnUrl, searchParams.toString());
};
